import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { EnvironmentParameters } from '../models/environment-parameters';
import { UtilsService } from '../services/utils.service';
import { CryptoDataService } from '../../core/services/crypto.data.service';
import { NgForm } from '@angular/forms';
import { IGenomeTime } from 'bz-genome-angular/time-picker/time-picker/bzg-time-picker.component';
import { GenomeTimeService } from 'app/shared/services/genome-time.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NavigationService } from 'app/core/services/navigation.service';
import { Router } from '@angular/router';

@Component({
    selector: 'environment-advanced',
    templateUrl: 'environment-advanced.component.html',
    styleUrls: ['environment-advanced.component.scss'],
})

export class EnvironmentAdvancedComponent {
    @Input() parameters: EnvironmentParameters;
    @Input() metadata: any;
    @Input() sections: any;
    @ViewChild('environmentAdvancedForm', { static: false}) environmentAdvancedForm: NgForm;
    private _timeDebounce = new Subject();

    public schedulerInterval: IGenomeTime;
    public limitSchedulerInterval: any;
    public hours = '99';

    public stringValue = {
      hours: '12',
      minutes: '0',
      seconds: '0',
    };

    public limitValues = {
      hours: {
        max: 23,
        min: 0
      },
      minutes: {
        max: 59,
        min: 0
      },
      seconds: {
        max: 59,
        min: 0
      }
    }

    constructor(public utilsService: UtilsService, private _cryptoDataService: CryptoDataService,
      private _genomeTimeService: GenomeTimeService, private _navigationService: NavigationService,
      private _router: Router ) {}

    ngOnInit(): void {
      this.schedulerInterval = this._convertSecondsToDate(this.parameters.bizagiSchedulerInterval);
      this._timeDebounce.pipe(debounceTime(200)).subscribe((data:any) => {
            this.schedulerInterval[data.section] = 0;
            let validValue = Number(data.value);
            validValue = validValue < this.limitValues[data.section].min ? this.limitValues[data.section].min
                  : validValue > this.limitValues[data.section].max ? this.limitValues[data.section].max : validValue;
            this.stringValue[data.section] = this.padForTwoDigits(validValue.toString());
            this.updateTime(data.section);
      });
      this._navigationService.updateMenus();
    }

    public async cryptographyKeyUrlPassword() {
        if (this.parameters.cryptographyKeyUrlFormat.Password !== null && this.parameters.cryptographyKeyUrlFormat.Password.length > 0) {
            const passwordResult = await this._cryptoDataService
              .encryptString(this.parameters.cryptographyKeyUrlFormat.Password)
              .toPromise();
            this.parameters.cryptographyKeyUrlFormat.Password = passwordResult.encryptedPassword;
        }
    };

    public validateMaxFileSize(){
        this.parameters.uploadMaxFileSize = this.parameters.uploadMaxFileSize > 999999999 ? 999999999 : this.parameters.uploadMaxFileSize;
    };

    public validateMaxLengthTreshold(){
        this.parameters.attribMaxLengthThreshold =
          this.parameters.attribMaxLengthThreshold > 9999
            ? 9999
            : this.parameters.attribMaxLengthThreshold;
    };

    public validatEntityInstancesThreshold(){
        this.parameters.paramEntityInstancesThreshold =
          this.parameters.paramEntityInstancesThreshold > 999999999
            ? 999999999
            : this.parameters.paramEntityInstancesThreshold;
    };

    public validateInterfaceThresholdTime(){
        this.parameters.interfaceThresholdTime =
          this.parameters.interfaceThresholdTime < -1
            ? -1
            : this.parameters.interfaceThresholdTime;
        this.parameters.interfaceThresholdTime =
          this.parameters.interfaceThresholdTime > 600
            ? 600
            : this.parameters.interfaceThresholdTime;
    };

    public updateValue(parameterName: string, event) {
        this.parameters[parameterName] = Number(event);
    }

    public isFormValid() : boolean {
        this.parameters.bizagiSchedulerInterval = this._convertDateToSeconds(this.schedulerInterval);
        let atLeastOneControlInvalid = false;
        Object.keys(this.environmentAdvancedForm.form.controls).map((c) => {
            const control = this.environmentAdvancedForm.form.controls[c];
            if (control.invalid) {
                atLeastOneControlInvalid = true;
            }
        });

        return !atLeastOneControlInvalid;
    }

    public onlyNumbers(event: any) {
      const pattern = /^\d{1,2}/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    };

    public validMinimun(){
      let count = 0;
      Object.keys(this.schedulerInterval).forEach((key)=> {
        if (!this.schedulerInterval[key]) {
          count++;
        }
      })

      if (count >= Object.keys(this.schedulerInterval).length) {
        this.schedulerInterval.seconds = 1;
      }
    }

    public checkValue(section: string, value:string) {
      this._timeDebounce.next({section, value});
    }

    public padForTwoDigits(stringvalue: string): string {
      return (stringvalue === '0' || (Number(stringvalue) < 10 && (stringvalue.indexOf('0') === -1)) ? '0' : '') + stringvalue;
    }

    public updateTime(section: string) {
      this.schedulerInterval[section] = Number(this.stringValue[section])
      this.validMinimun();
    }

    public goUp(section: string) {
      let numberValue = Number(this.stringValue[section]);
      if (numberValue < this.limitValues[section].max) {
        numberValue = numberValue + 1;
      }
      this.stringValue[section] = this.padForTwoDigits(numberValue.toString());
      this.updateTime(section);
    }

    public goDown(section: string) {
      let numberValue = Number(this.stringValue[section]);
      if (numberValue > this.limitValues[section].min) {
        numberValue = numberValue - 1;
      }
      this.stringValue[section] = this.padForTwoDigits(numberValue.toString());
      this.updateTime(section);
    }

    public navigateWindowMaintenance() {
      this._router.navigate(['mc', 'Maintenance']);
    }

    private _convertSecondsToDate(value: number) : IGenomeTime {
      const hours = Math.floor(value / 3600);
      const minutes = Math.floor(value % 3600 / 60);
      const seconds = Math.floor(value % 3600 % 60);
      return {
        hours,
        minutes,
        seconds,
        period: ''
      }
    }

    private _convertDateToSeconds(value: IGenomeTime) : number {
      let totalSeconds = 0;
      totalSeconds += value.hours * 60 * 60;
      totalSeconds += value.minutes * 60;
      totalSeconds += value.seconds;
      return totalSeconds;
    }

}
